var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".watch_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "watch_svg__b",
    d: "M7.556 17.556h8.889a2.207 2.207 0 002.222-2.191v-6.73a2.207 2.207 0 00-2.222-2.191H7.556a2.207 2.207 0 00-2.222 2.191v6.729a2.206 2.206 0 002.222 2.192zM16.444 6.286l-.68-2.621A2.22 2.22 0 0013.614 2h-3.228a2.222 2.222 0 00-2.151 1.665l-.68 2.621M7.556 17.714l.68 2.621A2.22 2.22 0 0010.386 22h3.228a2.221 2.221 0 002.151-1.665l.68-2.621"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "watch_svg__b",
    d: "M13.1 9.778a1.609 1.609 0 011.571 1.6c0 1.565-2.619 2.846-2.667 2.846s-2.667-1.281-2.667-2.846a1.609 1.609 0 011.571-1.6 1.443 1.443 0 011.1.475 1.451 1.451 0 011.1-.475z"
  })));
}
export default SvgWatch;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/watch.svg
// module id = 1040
// module chunks = 11